var _defineProperty = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _require = require('../errors'),
    JOSECritNotUnderstood = _require.JOSECritNotUnderstood,
    JWSInvalid = _require.JWSInvalid;

var DEFINED = new Set(['alg', 'jku', 'jwk', 'kid', 'x5u', 'x5c', 'x5t', 'x5t#S256', 'typ', 'cty', 'crit', 'enc', 'zip', 'epk', 'apu', 'apv', 'iv', 'tag', 'p2s', 'p2c']);

module.exports = function validateCrit(Err, protectedHeader, unprotectedHeader, understood) {
  if (protectedHeader && 'crit' in protectedHeader) {
    if (!Array.isArray(protectedHeader.crit) || protectedHeader.crit.length === 0 || protectedHeader.crit.some(function (s) {
      return typeof s !== 'string' || !s;
    })) {
      throw new Err('"crit" Header Parameter MUST be an array of non-empty strings when present');
    }

    var whitelisted = new Set(understood);

    var combined = _objectSpread({}, protectedHeader, {}, unprotectedHeader);

    protectedHeader.crit.forEach(function (parameter) {
      if (DEFINED.has(parameter)) {
        throw new Err("The critical list contains a non-extension Header Parameter ".concat(parameter));
      }

      if (!whitelisted.has(parameter)) {
        throw new JOSECritNotUnderstood("critical \"".concat(parameter, "\" is not understood"));
      }

      if (parameter === 'b64') {
        if (!('b64' in protectedHeader)) {
          throw new JWSInvalid('"b64" critical parameter must be integrity protected');
        }

        if (typeof protectedHeader.b64 !== 'boolean') {
          throw new JWSInvalid('"b64" critical parameter must be a boolean');
        }
      } else if (!(parameter in combined)) {
        throw new Err("critical parameter \"".concat(parameter, "\" is missing"));
      }
    });
  }

  if (unprotectedHeader && 'crit' in unprotectedHeader) {
    throw new Err('"crit" Header Parameter MUST be integrity protected when present');
  }
};